import React, { Component } from "react";
import clsx from "clsx";
import * as Icon from "react-feather";

import "./tools-activity-list.css";

const ROW_ICONS = {
	pending: Icon.Circle,
	working: Icon.Loader,
	resolved: Icon.CheckCircle,
	done: Icon.Check,
	attention: Icon.AlertCircle,
	error: Icon.XCircle,
};

const SPOKEN_STATUS = {
	pending: "Not started",
	working: "In progress",
	resolved: "Resolved",
	done: "Done",
	attention: "Needs attention",
	error: "Failed",
	waiting: "Waiting",
	skipped: "Skipped",
};

const SUBSTEP_ICONS = {
	pending: Icon.Circle,
	working: Icon.Loader,
	done: Icon.Check,
	waiting: Icon.Clock,
	skipped: Icon.Minus,
	error: Icon.AlertCircle,
};

class ToolsActivityList extends Component {
	renderHeader() {
		const { status, substatus, isWorking, progress } = this.props;
		if (!status) return null;
		return (
			<div className="tools-activity-list__header" role={isWorking ? "status" : undefined} aria-live={isWorking ? "polite" : undefined}>
				{isWorking && <div className="tools-activity-list__spinner" aria-hidden="true" />}
				<div className="tools-activity-list__headline">
					<div className="tools-activity-list__status">{status}</div>
					{substatus && <div className="tools-activity-list__substatus">{substatus}</div>}
				</div>
				{progress && (
					<div className="tools-activity-list__progress">
						<span className="tools-activity-list__progress-count">
							{progress.done} / {progress.total}
						</span>
						<span className="tools-activity-list__progress-label">{progress.label}</span>
					</div>
				)}
			</div>
		);
	}

	renderSubstep = substep => {
		const SubstepIcon = SUBSTEP_ICONS[substep.status] || Icon.Circle;
		return (
			<div key={substep.key} className={clsx("tools-activity-list__substep", `tools-activity-list__substep--${substep.status}`)}>
				<SubstepIcon size={11} aria-hidden="true" className={clsx("tools-activity-list__substep-icon", substep.status === "working" && "tools-activity-list__icon--spin")} />
				<span className="tools-activity-list__spoken">{SPOKEN_STATUS[substep.status] || ""}: </span>
				<span className="tools-activity-list__substep-label">{substep.label}</span>
				{substep.detail && <span className="tools-activity-list__substep-detail">{substep.detail}</span>}
			</div>
		);
	};

	renderItem = item => {
		const RowIcon = ROW_ICONS[item.status] || Icon.Circle;
		const hasSubsteps = Array.isArray(item.substeps) && item.substeps.length > 0;
		return (
			<div key={item.key} id={item.anchorId} className="tools-activity-list__item">
				<div
					className={clsx(
						"tools-activity-list__row",
						`tools-activity-list__row--${item.status}`,
						item.isEmphasised && "tools-activity-list__row--emphasised",
						item.isHighlighted && "tools-activity-list__row--highlighted",
						item.isSetAside && "tools-activity-list__row--set-aside",
					)}
				>
					<RowIcon size={14} aria-hidden="true" className={clsx("tools-activity-list__icon", item.status === "working" && "tools-activity-list__icon--spin")} />
					<span className="tools-activity-list__spoken">{SPOKEN_STATUS[item.status] || ""}: </span>
					{item.code && <span className="tools-activity-list__code">{item.code}</span>}
					<span className="tools-activity-list__label">
						{item.label}
						{item.note && <span className="tools-activity-list__note">{item.note}</span>}
					</span>
					{item.chip && <span className="tools-activity-list__chip">{item.chip}</span>}
					{item.detail && <span className="tools-activity-list__detail">{item.detail}</span>}
					{(item.value || item.valueTag) && (
						<span className="tools-activity-list__value">
							{item.valueTag && <span className="tools-activity-list__value-tag">{item.valueTag}</span>}
							{item.value}
						</span>
					)}
				</div>
				{hasSubsteps && <div className="tools-activity-list__substeps">{item.substeps.map(this.renderSubstep)}</div>}
			</div>
		);
	};

	render() {
		const { items = [], isInline } = this.props;
		return (
			<div className={clsx("tools-activity-list", isInline && "tools-activity-list--inline")}>
				{this.renderHeader()}
				{items.length > 0 && <div className="tools-activity-list__items">{items.map(this.renderItem)}</div>}
			</div>
		);
	}
}

export default ToolsActivityList;
